<template>
    <div v-if="content || media">
        <!-- <label @click="concern = false" style="z-index:99999999999999999999999; position: fixed; top: 0; " class="warn p8 white" v-if="content.includes('<iframe') && concern">Attention: an iframe is present on this page. This may enable phishing or other security vulnerablities. <p class="xs-font">(click to remove warning)</p></label> -->
        <vue-markdown :content="!content ? '' : typeof content == 'object' ? JSON.stringify(content, null, 4) : content" :options="{markdownIt: {linkify: true, inline: true, html: true}}" :class="content.includes('<iframe') && 'warn-border' "/>
        <div v-if="media && media.length > 0 && $store.state.users[$store.state.auth.uid].files[media] && $store.state.users[$store.state.auth.uid].files[media].url.length > 0" :class="`${name}_media`">
            <!-- 1. {{media}}
            2. {{ $store.state.users[$store.state.auth.uid].files[media] }} -->
            <img :class="`media_${imagei}`" v-for="(image, imagei) in media" :key="imagei" :src="$store.state.users[$store.state.auth.uid].files[media].url[0]" alt="media">
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            name: {type: String},
            content: {type: String },
            media: {type: Array},
            data: {type: Object},
        },
        data() {
            return {
                concern: true
            }
        },
    }
</script>